import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { googleLogout } from '@react-oauth/google';
import apiClient from '../services/apiClient';
import { isFirstPartyRedirect } from '../utils/firstPartyRedirect';

export default function LogoutPage() {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  // 999.18683 — auth-service could not finish ending the server session.
  const incomplete = searchParams.get('logout_incomplete') === '1';
  const destination = (redirect && isFirstPartyRedirect(redirect)) ? redirect : '/login';

  useEffect(() => {
    // Clear auth-service tokens from localStorage
    apiClient.clearTokens();
    localStorage.removeItem('auth_user');

    // Revoke Google session so One Tap doesn't auto-sign-in
    try {
      googleLogout();
    } catch {
      // Not critical if this fails
    }

    // Redirect to the calling app only when it is a first-party target;
    // an unvalidated ?redirect= here is an open redirect (999.2085). Otherwise
    // fall back to the auth login page. An incomplete logout stays here so the
    // user is told rather than shown a clean sign-out (999.18683).
    if (!incomplete) window.location.href = destination;
  }, [destination, incomplete]);

  if (!incomplete) return null;
  return (
    <div role="alert">
      <p>Sign-out could not be fully completed on the server. Your session may stay active for up to an hour on other Raike apps.</p>
      <a href={destination}>Continue</a>
    </div>
  );
}
